import NewEditSeriePage from "@/Pages/Series/NewEditSeriePage.vue";
import SeriesIndexPage from "@/Pages/Series/index.vue";

export default [
  {
    component: NewEditSeriePage,
    name: "series.create",
    path: "/series/create",
    props: { editing: false },

    beforeEnter: (to, from, next) => {
      if (from.name) {
        next();
        return;
      }

      next({ name: "series" });
    },
  },
  {
    component: NewEditSeriePage,
    name: "series.edit",
    path: "/series/edit/:serie_id",
    props: { editing: true },
  },
  {
    component: SeriesIndexPage,
    name: "series",
    path: "/series/",
  },
];
